<div class="content">
    <!-- <img src="assets/login/background.png" class="bglogo" > -->
    <nz-layout class="app-layout">
        <nz-header>
            <div class="app-header">
                <div class="header-content"> 
                    <div class="header">
                        <div class="title">
                            <img src="assets/login/sje_logo_login.png" style="margin-left:20px;" />
                            <!-- <span class="title-text"> {{"Common.SystemName" | translate}}</span> -->
    
                        </div>
                    </div>
                </div>
            </div>
        </nz-header>
        <div  class="container">
            <div class="login">
                <router-outlet></router-outlet>
            </div>
        </div>
    </nz-layout>

</div>